type LimitPayloadBase = {
  total_amount_limits: TotalAmountLimitsPayload;
  product_liters_limits: ProductLitersLimitPayload[];
}

export type LimitDriverPayload = LimitPayloadBase & {
  user_id: number | null;
}

export type LimitCarPayload = LimitPayloadBase & {
  machinery_id: number | null;
}

export function isLimitDriverPayload(payload: LimitDriverPayload | LimitCarPayload): payload is LimitDriverPayload {
  return (payload as LimitDriverPayload).user_id !== undefined;
}

export function isLimitCarPayload(payload: LimitDriverPayload | LimitCarPayload): payload is LimitCarPayload {
  return (payload as LimitCarPayload).machinery_id !== undefined;
}

export type TotalAmountLimitsPayload = {
  amount: number | null;
  period_limit: PeriodLimitPayload;
}

export type PeriodLimitPayload = {
  type: number | null;
  amount: number | null;
  unit?: number | null;
}

export type ProductLitersLimitPayload = {
  product_id: number | null;
  period_limit: PeriodLimitPayload;
  total_limit: number | null;
  deleted: number | null;
}

export type PartialProductLitersLimitPayload = Partial<{
  product_id: number | null;
  period_limit: Partial<PeriodLimitPayload>;
  total_limit: number | null;
  deleted: number | null;
}>

export const transformToLimitPayload = (partial: Partial<{
  user_id: number | null;
  machinery_id: number | null;
  total_amount_limits: Partial<{
    amount: number | null;
    period_limit: Partial<PeriodLimitPayload>;
  }>;
  product_liters_limits: Array<Partial<{
    product_id: number | null;
    period_limit: Partial<PeriodLimitPayload>;
    total_limit: number | null;
    deleted: number | null;
  }>>;
}>): LimitDriverPayload | LimitCarPayload => {
  return {
    user_id: partial.user_id ?? null,
    machinery_id: partial.machinery_id ?? null,
    total_amount_limits: {
      amount: partial.total_amount_limits?.amount ?? null,
      period_limit: {
        type: partial.total_amount_limits?.period_limit?.type ?? null,
        amount: partial.total_amount_limits?.period_limit?.amount ?? null,
        unit: partial.total_amount_limits?.period_limit?.unit ?? null,
      }
    },
    product_liters_limits: (partial.product_liters_limits ?? []).map(pl => ({
      product_id: pl?.product_id ?? null,
      period_limit: {
        type: pl?.period_limit?.type ?? null,
        amount: pl?.period_limit?.amount ?? null,
        unit: pl?.period_limit?.unit ?? null,
      },
      total_limit: pl?.total_limit ?? null,
      deleted: pl?.deleted ?? null,
    }))
  };
};